// src/models/fiscal/Seguradora.js
export class Seguradora {
  constructor(data = {}) {
    this.id = data.id ?? 0;
    this.filialId = data.filialId ?? 1;
    this.nome = data.nome ?? '';
    this.cnpj = data.cnpj ?? '';
    this.ativo = data.ativo ?? true;
  }
}
